import { Injectable } from '@angular/core';
import { APP_CONST } from '../../../app.const';
import { RequestService } from '../../../libraries/http/request.service';

@Injectable()
export class DashboardDealerRestService {
  baseURL = `${APP_CONST.API_MASTER}/admin`;
  request = this._request.new(this.baseURL);

  constructor(private _request: RequestService) {}

  getCreditNoteHistories(qParams: any) {
    return this.request.get<any>(`/credit-note/dealer-history`, { params: qParams });
  }

  getCreditNoteInsight() {
    return this.request.get<any>(`/credit-note/dealer-insight`);
  }
}
